export default __webpack_public_path__ + "media/images/mailer/logo_transparent-2e7bae09d37a0c51204b5ba92a653bd5.png";